import { computed } from 'mobx';
import type { IComputedValue } from 'mobx';

import { actionMenuStore } from '../../stores';

export const isEditRegistration: IComputedValue<boolean> = computed(() => {
  const distance = actionMenuStore.distanceModel;
  if (!distance || !distance.value.editInformationSettings) {
    return false;
  }

  return !(distance.isTeam() && !distance.value.is_team_leader);
});
